// @ts-nocheck
import { sectionRenderer } from '@theme/section-renderer';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('product-tabs');
  if (!container) return;

  const tabButtons = Array.from(container.querySelectorAll('.product-tab-button'));
  const tabPanels = Array.from(container.querySelectorAll('.product-tab-panel'));
  const tabList = container.querySelector('.product-tabs-list') || container.querySelector('[role="tablist"]');
  const loadedLazySections = new Set();

  // Scroll tab into view ONLY if it's currently overflowing/out of view
  function scrollTabIntoViewIfNeeded(button) {
    if (!tabList || !button) return;

    const containerRect = tabList.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();

    const isFullyVisible =
      buttonRect.left >= containerRect.left &&
      buttonRect.right <= containerRect.right;

    if (isFullyVisible) return;

    button.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }

  function loadLazyPanel(panel) {
    const sectionId = panel.dataset.lazySection;
    if (!sectionId || loadedLazySections.has(sectionId)) return;
    loadedLazySections.add(sectionId);

    sectionRenderer
      .renderSection(sectionId)
      .then(() => {
        panel.dispatchEvent(new CustomEvent('lazy-section:loaded', { bubbles: true, detail: { sectionId } }));
      })
      .catch((error) => {
        loadedLazySections.delete(sectionId);
        console.error(`Failed to lazily render section "${sectionId}":`, error);
      });
  }

  function setActiveTab(targetIndex, focusButton = false) {
    const targetPanel = container.querySelector(`[data-tab-content="${targetIndex}"]`);
    if (!targetPanel && tabPanels.length > 0) {
      const firstAvailableIndex = tabPanels[0].getAttribute('data-tab-content');
      setActiveTab(firstAvailableIndex, focusButton);
      return;
    }

    tabButtons.forEach((button) => {
      const isTarget = button.getAttribute('data-tab-target') === String(targetIndex);
      button.classList.toggle('is-active', isTarget);
      button.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      button.setAttribute('tabindex', isTarget ? '0' : '-1');

      if (isTarget) {
        scrollTabIntoViewIfNeeded(button);
        if (focusButton) button.focus();
      }
    });

    tabPanels.forEach((panel) => {
      const isTarget = panel.getAttribute('data-tab-content') === String(targetIndex);
      panel.classList.toggle('is-active', isTarget);
      panel.hidden = !isTarget;
      if (isTarget) loadLazyPanel(panel);
    });
  }

  // Click & Keyboard Event Handlers
  tabButtons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const targetIndex = button.getAttribute('data-tab-target');
      setActiveTab(targetIndex);
    });

    // WAI-ARIA Keyboard Navigation (Left/Right Arrow, Home, End)
    button.addEventListener('keydown', (e) => {
      let targetBtn = null;

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        targetBtn = tabButtons[(index + 1) % tabButtons.length];
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        targetBtn = tabButtons[(index - 1 + tabButtons.length) % tabButtons.length];
      } else if (e.key === 'Home') {
        e.preventDefault();
        targetBtn = tabButtons[0];
      } else if (e.key === 'End') {
        e.preventDefault();
        targetBtn = tabButtons[tabButtons.length - 1];
      }

      if (targetBtn) {
        const targetIndex = targetBtn.getAttribute('data-tab-target');
        setActiveTab(targetIndex, true);
      }
    });
  });

  window.addEventListener('show-description', () => {
    setActiveTab(0);
  });

  if (tabButtons.length > 0) {
    const initialIndex = tabButtons[0].getAttribute('data-tab-target');
    setActiveTab(initialIndex);
  }

  function prefetchLazyPanels() {
    tabPanels.forEach((panel) => {
      if (panel.dataset.lazySection) loadLazyPanel(panel);
    });
  }

  if (document.readyState === 'complete') {
    prefetchLazyPanels();
  } else {
    window.addEventListener('load', prefetchLazyPanels, { once: true });
  }
});